module.exports = __webpack_public_path__ + "img/icon-plumber.5d27bfb4.png";